import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '@/shared/lib/cn';

const labelVariants = cva(
  'text-xs mx-2 backdrop-opacity-0 h-4 text-sm flex flex-col justify-center font-300',
  {
    variants: {
      variant: {
        default: 'text-border-input',
        error: 'text-error',
        warning: 'text-warning',
        success: 'text-success',
        info: 'text-info',
        disabled: 'text-disabled',
        empty: 'text-transparent',
      },
      defaultVariants: {
        variant: 'default',
      },
    },
  },
);

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, variant, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants({ variant }), className)} {...props} />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
